import React from 'react'
import { Redirect } from 'react-router-dom'
import { modules } from '../../../modules'
import ProtectedRoute from '../../internal/ProtectedRoute'
import useModuleMenu from '../../hooks/useModuleMenu'
import PaymentManagementModule from './PaymentManagementModule'
import useQueryParams from './useQueryParams'
import { isPaymentManagementModuleEnabled } from './paymentManagementModuleUtils'

const PaymentManagementRoutes = ({ authorities, representativeId }) => {
  if (authorities?.length) {
    const menuData = useModuleMenu(
      modules.paymentManagementApp,
      authorities,
      isPaymentManagementModuleEnabled(representativeId),
    )
    const queryParamsHandler = useQueryParams()

    if (menuData?.menu?.route) {
      const { authority, key, route } = menuData.menu

      return [
        <ProtectedRoute
          authority={authority}
          key={`${key}-redirect`}
          path={modules.paymentManagementApp.basePath}
          page={<Redirect to={route} replace />}
        />,
        <ProtectedRoute
          authority={authority}
          key={key}
          path={route}
          page={
            <PaymentManagementModule queryParamsHandler={queryParamsHandler} />
          }
        />,
      ]
    }
  }

  return []
}

export default PaymentManagementRoutes
